export default __webpack_public_path__ + "static/media/movie-episode-7.3024e4ad.jpg";